import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.nav `
  height: 100%;
  max-width: max-content;
  margin: 0;
`;
const ItemList = styled.ul `
  height: 100%;
  display: flex;
  align-items: center;
  column-gap: 1px;
  justify-content: flex-end;
`;
const Item = styled.li `
  height: 100%;
  flex: 0 1 auto;
`;
const Link = styled.a `
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  box-sizing: content-box;
  color: ${brand.black};
  ${fonts.helvetica.regular};
  font-size: 18px;
  letter-spacing: -0.01em;
  line-height: 1.1;
  padding: 0 12px;
  text-decoration: none;
  transition: 0.3s ease background-color, 0.3s ease color;

  > svg {
    display: block;
    height: 24px;
    width: 24px;
    flex: 0 0 24px;
    margin-left: 6px;
  }

  ${Item}[data-d-active='true'] & {
    background-color: ${brand.yellow.base};
    color: ${brand.black};
  }

`;
const SearchIconLink = styled(Link) `
  > svg {
    margin-left: 0;
  }

  &:hover {
    background-color: transparent;
  }
`;
const DesktopNavigationStyles = {
    Container,
    Item,
    ItemList,
    Link,
    SearchIconLink,
};
export default DesktopNavigationStyles;
